//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class TaxDefinitionSearchOptions extends ItemBase {
    IDs: string[] = [];
    Active: boolean | null = null;
    Default: boolean | null = null;

    constructor(initializer?: Partial<TaxDefinitionSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TaxDefinitionSearchOptions";
}
